import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  tabKeys: [],
  tabIndex: -1
};

export const tabState = createSlice({
  name: "tabState",
  initialState,
  reducers: {
    updateTabState: (state, action) => {
      const { tabKeys, tabIndex } = action.payload;
      state.tabKeys = tabKeys;
      state.tabIndex = tabIndex;
    },
    updateTabIndex: (state, action) => {
      const { tabIndex } = action.payload;
      state.tabIndex = tabIndex;
    },
    initTabState: (state) => {
      state.tabKeys = [];
      state.tabIndex = -1;
    },
  }
})

export const { updateTabState, updateTabIndex, initTabState } = tabState.actions;

export default tabState.reducer;